import React, { useRef, useCallback } from 'react';
import { Close16 } from '@carbon/icons-react';
import { Link } from 'carbon-components-react';

import { useEventListener } from 'utilities/hooks.util';

const EnquiryLimitReached: React.FC<Props> = ({
  handleCloseIconClick,
  isAnonymousView = false
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (evt: any) => {
      const systemToastAlert = document
        .getElementsByClassName('system-alert')
        .item(0);
      const previewer = document
        .getElementsByClassName('previewer-modal')
        .item(0);
      const excludeFilesModal = document
        .getElementsByClassName('exclude-files-modal')
        .item(0);
      if (containerRef.current && evt.target) {
        if (
          !containerRef.current.contains(evt.target) &&
          !previewer &&
          !systemToastAlert &&
          !excludeFilesModal
        ) {
          !isAnonymousView && handleCloseIconClick();
        }
      }
    },
    [containerRef, handleCloseIconClick, isAnonymousView]
  );

  useEventListener('mousedown', handleClickOutside);
  useEventListener('touchstart', handleClickOutside);

  return (
    <>
      <div className="enquiry-details-rc-modal-limit-reached">
        <section
          ref={containerRef}
          className={`enquiry-details-rc-modal-main ${
            isAnonymousView ? 'anonymous-view' : ''
          }`}
        >
          <div className="close-button-container">
            {!isAnonymousView && (
              <div
                className="close-button-body"
                onClick={() => handleCloseIconClick()}
              >
                <Close16 />
              </div>
            )}
          </div>

          <div className="modal-container">
            <div className="modal-header-container">
              Transactions limits reached
            </div>

            <div className={`modal-content-container`}>
              <div className="text-wrapper">
                <p>
                  Maximum number of transactions reached.
                  <br />
                  For more information, please call us on{' '}
                  <Link href="tel:1300635196" target="_blank">
                    1300 635 196
                  </Link>{' '}
                  or submit a support request by email here{' '}
                  <Link
                    href="mailto:support@esriaustralia.com.au"
                    target="_blank"
                  >
                    support@esriaustralia.com.au
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

EnquiryLimitReached.displayName = 'EnquiryLimitReached';

type Props = {
  handleCloseIconClick?: any;
  isAnonymousView?: boolean;
};

export default React.memo(EnquiryLimitReached);
